import type { ResolutionEnumNoPrefix } from '@talos/kyoko';

/**
 * Mapping of discrepancies between ResolutionEnumNoPrefix and TradingView's ResolutionString.
 * Only includes resolutions where the values differ.
 */
const MAP_RESOLUTION_TO_TV_RESOLUTION: Partial<Record<ResolutionEnumNoPrefix, string>> = {
  '1M': '1',
  '5M': '5',
  '10M': '10',
  '15M': '15',
  '30M': '30',
  '1H': '60',
  '4H': '240',
  '1MO': '1M',
};

const MAP_TV_RESOLUTION_TO_RESOLUTION = Object.fromEntries(
  Object.entries(MAP_RESOLUTION_TO_TV_RESOLUTION).map(([k, v]) => [v, k])
) as Partial<Record<string, ResolutionEnumNoPrefix>>;

/**
 * Converts a ResolutionEnumNoPrefix to TradingView's ResolutionString.
 * If no mapping exists, returns the resolution as-is (cast to ResolutionString).
 */
export function toTradingViewResolution(resolution: ResolutionEnumNoPrefix): string {
  return MAP_RESOLUTION_TO_TV_RESOLUTION[resolution] ?? resolution;
}

/**
 * Converts a TradingView ResolutionString to ResolutionEnumNoPrefix.
 * If no mapping exists, returns the resolution as-is (cast to ResolutionEnumNoPrefix).
 */
export function fromTradingViewResolution(resolution: string): ResolutionEnumNoPrefix {
  return (MAP_TV_RESOLUTION_TO_RESOLUTION[resolution] ?? resolution) as ResolutionEnumNoPrefix;
}
